import { Trans, useTranslation } from 'react-i18next';
import Marker from '../../ui/Marker/Marker';
import PillLink from '../../ui/PillLink/PillLink';
import Section from '../../ui/Section/Section';
import { CONTACT_EMAIL, CONTACT_PATH, mailtoHref } from '../../../data/navigation';
import { useLanguage } from '../../../i18n/useLanguage';
import styles from './ContactSection.module.css';

export default function ContactSection() {
    const { t } = useTranslation();
    const { localizedPath } = useLanguage();
    const draftHref = mailtoHref(t('contactPage.offer.mailSubject'), t('contactPage.offer.mailBody'));

    return (
        <Section theme="light" shape="sheet" id="contact" labelledBy="contact-title" className={styles.contact}>
            <div className={`page-inner ${styles.inner}`}>
                <h2 id="contact-title" className={styles.title}>
                    <Trans i18nKey="contact.title" components={{ mark: <Marker /> }} />
                </h2>
                <div className={styles.row}>
                    <div className={styles.text}>
                        <p className={styles.body}>{t('contact.body')}</p>
                        <p className={styles.offer}>{t('contact.offer')}</p>
                    </div>
                    <div className={styles.actions}>
                        <PillLink href={localizedPath(CONTACT_PATH)} size="large" icon="arrowRight">{t('contact.action')}</PillLink>
                        <PillLink href={draftHref} variant="outline" size="large" icon="mail">{t('contact.offerAction')}</PillLink>
                    </div>
                </div>
                <a className={styles.email} href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
            </div>
        </Section>
    );
}
